// extracted by mini-css-extract-plugin
export default {"container":"Admin_container__1D9mX","header":"Admin_header__qU7nQ","tabsWrapper":"Admin_tabsWrapper__WTMKF"};